// extracted by mini-css-extract-plugin
export default {"wrapper":"O3-z","play":"P3-z"};